import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectFirstIncompleteLessonTaskStep } from './first-incomplete-lesson-task-step.selector.ts';

export const selectLastCompletedLesson = createMemoizedSelector(
  selectFirstIncompleteLessonTaskStep,
  (firstIncompleteLessonTaskStepKey): number => {
    return firstIncompleteLessonTaskStepKey.lesson - 1;
  }
);
